{
  "arg": {
    "name": {},
    "value": {}
  },
  "cancel": {},
  "fail": {
    "back": {},
    "cancel": {},
    "tryAgain": {}
  },
  "report": {},
  "run": {},
  "success": {
    "close": {}
  }
}
